/*
  CT: gedrag van het hoofdmenu (okt 2026).

  Geladen als los <script defer> vanuit snippets/preload-js.liquid, net als
  de andere ct-scripts: geen ES module, geen imports, buiten de
  importmap-keten. Voorheen stonden beide delen inline in de snippets; nu
  cachebaar en niet meer in de HTML van elke pagina.

  defer = draait na het parsen, vóór DOMContentLoaded. #MobileNav en de
  sliders bestaan dan al. De header hydrateert later (is-land on:idle);
  de events van mobile-nav.js ('MobileNav:open') komen dus pas na het
  registreren van de listeners hieronder.

  1. Desktop: vorige/volgende in de productslider van het megamenu
     (snippets/header-desktop-nav.liquid, .ct-feat__slider).
  2. Mobiel: paneelhoogte, submenu-hoogte en 'Taal en land'
     (snippets/header-mobile-nav.liquid, #MobileNav).
*/
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1. Desktop: productslider (scroll-snap, gedelegeerd)
  --------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ct-feat-prev], [data-ct-feat-next]');
    if (!btn) return;
    var slider = btn.closest('.ct-feat__slider');
    var track = slider && slider.querySelector('[data-ct-feat-track]');
    if (!track) return;
    e.preventDefault();
    var dir = btn.hasAttribute('data-ct-feat-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  });

  /* ---------------------------------------------------------------
     2. Mobiel menu
  --------------------------------------------------------------- */
  var nav = document.getElementById('MobileNav');
  if (!nav) return;
  var scroller = nav.querySelector('.site-header__drawer-animate');
  var wrapper = nav.querySelector('.slide-nav__wrapper');
  var root = document.documentElement;
  var settleTimer = null;

  function isOpen() {
    return root.classList.contains('mobile-nav-open');
  }

  // Na twee frames is de klasse is-active gezet en de opmaak berekend
  // (het thema zet is-active via prepareTransition, niet synchroon).
  function afterLayout(fn) {
    requestAnimationFrame(function () { requestAnimationFrame(fn); });
  }

  /*
    Verschuiving door een lopende in-animatie (translateY) van het paneel
    of #MobileNav zelf. 8-10 (QA David, mobiel): bij het openen werd de
    bovenkant gemeten terwijl het paneel nog inschoof; die positie lag te
    hoog, het paneel werd langer dan het scherm en 'Taal en land' viel
    onderaan buiten beeld. We trekken de verschuiving eraf en meten zo
    de eindpositie.
  */
  function shiftY(el) {
    if (!el) return 0;
    var t = window.getComputedStyle(el).transform;
    if (!t || t === 'none') return 0;
    try {
      return new DOMMatrixReadOnly(t).m42 || 0;
    } catch (err) {
      return 0;
    }
  }

  /*
    Paneelhoogte: zichtbare viewport min de eindpositie van de bovenkant
    van het paneel. Het thema (size-drawer.js) rekent met de hoogte van
    #HeaderWrapper; dat klopt niet als er een aankondigingsbalk boven de
    header staat of als de pagina gescrold is. visualViewport houdt
    rekening met de in- en uitschuivende adresbalk op mobiel.
  */
  function setMax() {
    var vv = window.visualViewport;
    var vh = vv ? vv.height + (vv.offsetTop || 0) : window.innerHeight;
    var el = scroller || nav;
    var top = el.getBoundingClientRect().top - shiftY(el) - (el === nav ? 0 : shiftY(nav));
    top = Math.max(0, top);
    var max = Math.max(240, Math.floor(vh - top));
    nav.style.setProperty('--ctMnavMax', max + 'px');
  }

  /*
    Submenu-hoogte: mobile-nav.js zet de wrapper eenmalig op de gemeten
    hoogte van het actieve submenu. Wordt dat submenu daarna nog hoger
    (lettertype laadt later, badges), dan viel de rest weg. Hier houden
    we de wrapper gelijk aan het actieve submenu.
  */
  function syncWrapper() {
    if (!wrapper) return;
    if (!wrapper.dataset.level || wrapper.dataset.level === '1') return;
    var active = wrapper.querySelector('.slide-nav__dropdown.is-active');
    if (active) wrapper.style.height = active.offsetHeight + 'px';
  }

  function refresh() {
    if (!isOpen()) return;
    setMax();
    syncWrapper();
  }

  // Nog een keer meten nadat de in-animatie van het thema klaar is.
  function settle() {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(refresh, 450);
  }

  document.addEventListener('MobileNav:open', function () {
    if (scroller) scroller.scrollTop = 0;
    setMax();
    afterLayout(refresh);
    settle();
  });

  nav.addEventListener('transitionend', refresh);
  nav.addEventListener('animationend', refresh);

  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('orientationchange', function () { afterLayout(refresh); settle(); });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', refresh, { passive: true });
  }

  if ('ResizeObserver' in window && wrapper) {
    var ro = new ResizeObserver(function () { syncWrapper(); });
    wrapper.querySelectorAll('.slide-nav__dropdown').forEach(function (d) { ro.observe(d); });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncWrapper);
  }

  nav.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    // Wisselen van niveau: terug naar boven, daarna hoogtes bijwerken
    // (dit draait na de handler van het thema op dezelfde knop).
    if (e.target.closest('.js-toggle-submenu')) {
      if (scroller) scroller.scrollTop = 0;
      afterLayout(refresh);
      return;
    }

    /*
      'Taal en land': menu sluiten en de bestaande kiezer openen via zijn
      eigen trigger (#locale-trigger in language-switcher.liquid). Een
      programmatische click werkt ook als de trigger verborgen is
      (ct-nav.css §15), en de kiezer houdt zo één bron van waarheid.
    */
    if (e.target.closest('[data-ct-locale-open]')) {
      e.preventDefault();
      var trigger = document.getElementById('locale-trigger');
      if (!trigger) return;
      document.dispatchEvent(new CustomEvent('mobileNav:close'));
      setTimeout(function () { trigger.click(); }, 0);
    }
  });
})();
